(function(){
  var SWATCH_SEL = '.color-swatch, .thumbnail-swatch';
  var SWATCH_LINK_SEL = '[data-card-swatches-track] a.color-swatch, [data-card-swatches-track] a.thumbnail-swatch';
  var cache = Object.create(null);

  function fetchProduct(handle, signal){
    if (!handle) return Promise.resolve(null);
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js', { credentials: 'same-origin', signal: signal })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ if (j) cache[handle] = j; return j; });
  }

  // Product images are stored at their original size — the Fall collection runs
  // 4:5 up to 4245x5307, which is ~90 MB of DECODED bitmap for a single image.
  // The raw product.images URL carries no width param, so warming those was
  // pulling originals into ~200px card slots and exhausting memory on iOS.
  // A PLP card is never wider than ~500 CSS px, so 1000 covers a 2x screen.
  var PRELOAD_WIDTHS = [200, 300, 400, 500, 600, 700, 800, 1000];
  // Fallback only. Prefer the card's own rendered sizes (see cardSizes) so the
  // warm resolves to the exact candidate the render will request — otherwise
  // the browser fetches a second, differently-sized file and the warm is wasted.
  var PRELOAD_SIZES_FALLBACK = '(max-width: 699px) 50vw, (max-width: 999px) 33vw, calc((100vw - 96px) / 3 - 16px)';

  function cardSizes(cardEl){
    if (cardEl) {
      var ref = cardEl.querySelector('[data-gallery-track] img[sizes]');
      if (ref) {
        var v = ref.getAttribute('sizes');
        if (v) return v;
      }
    }
    return PRELOAD_SIZES_FALLBACK;
  }
  function sizedUrl(url, w){
    if (!url) return url;
    var base = url.split('&width=')[0].split('?width=')[0];
    return base + (base.indexOf('?') === -1 ? '?' : '&') + 'width=' + w;
  }
  function sizedSrcset(url){
    if (!url) return '';
    return PRELOAD_WIDTHS.map(function(w){ return sizedUrl(url, w) + ' ' + w + 'w'; }).join(', ');
  }

  function preload(url, sizesAttr){
    if (!url) return Promise.resolve();
    var img = new Image();
    img.decoding = 'async';
    // srcset/sizes MUST be assigned before src or the raw fetch has already begun.
    var ss = sizedSrcset(url);
    if (ss) { img.sizes = sizesAttr || PRELOAD_SIZES_FALLBACK; img.srcset = ss; }
    img.src = ss ? sizedUrl(url, 600) : url;
    // Deliberately NOT calling img.decode(): it forces the full bitmap resident
    // for every warmed image, which is what actually crashed/reloaded the tab on
    // iOS. onload populates the HTTP cache, which is all a warm needs — decoding
    // happens at render time for the handful of images actually displayed.
    return new Promise(function(resolve){ img.onload = img.onerror = resolve; });
  }

  function handleFromHref(href){
    var m = (href || '').match(/\/products\/([^\/\?]+)/);
    return m ? m[1] : null;
  }

  function card(el){ return el.closest('product-card.product-card'); }
  function mediaLink(c){ return c ? c.querySelector('a.product-card__media') : null; }
  function figureEl(c){ return c ? c.querySelector('.product-card__figure') : null; }
  function titleLink(c){ return c ? c.querySelector('a.product-title') : null; }
  function colorLink(c){ return c ? c.querySelector('a.product-color') : null; }
  function dsgEl(c){ return c ? c.querySelector('[data-dsg]') : null; }
  function priceEl(c){ return c ? c.querySelector('price-list, .product-card__sold-out-price') : null; }
  function quickAddLinkEl(c){ return c ? c.querySelector('.quick-add-link') : null; }
  function quickAddSizesRoot(c){ return c ? c.querySelector('.product-card__hover-reveal .quick-add-sizes') : null; }

  // ── Full-card colorway preload (mirrors Three Nails) ──────────────────────
  // On first interaction with a card's photo swiper, warm EVERY image of EVERY
  // colorway on that card (all swatches, up to the 5 gallery slides each) so
  // colorway swaps and further swipes are instant. Once per card. Routed through
  // a small concurrency queue (max 4) so a many-color card doesn't burst the net.
  var PRELOAD_MAX_CONCURRENT = 4;
  var PRELOAD_MAX_COLORWAYS = 12;
  var _plInflight = 0;
  var _plQueue = [];
  function _plSchedule(task){ _plQueue.push(task); _plDrain(); }
  function _plDrain(){
    if (_plInflight >= PRELOAD_MAX_CONCURRENT || !_plQueue.length) return;
    _plInflight++;
    var fn = _plQueue.shift();
    var done = function(){ _plInflight--; _plDrain(); };
    try { var p = fn(); if (p && p.then) p.finally(done); else done(); } catch(e){ done(); }
  }
  window.__preloadCardColorways = function(cardEl){
    if (!cardEl || cardEl.__allColorsPreloaded) return;
    cardEl.__allColorsPreloaded = true;
    // Current colorway: flip the lazy slides to eager so the browser pulls the
    // sized candidates it would fetch on swipe anyway.
    cardEl.querySelectorAll('[data-gallery-track] img').forEach(function(img){
      try { img.loading = 'eager'; } catch(_){}
    });
    // Every swatch: fetch the product JSON and warm all gallery images — the
    // same raw URLs rebuildGallery() assigns on swap, so swaps hit cache.
    // Only the FIRST image of each colorway — the one a swap shows immediately.
    // Remaining slides lazy-load on swipe as normal. And cap the colorways: the
    // worst card on the site has 28 swatches, which at 5 images each meant 109
    // full-size images fetched and decoded from a single touch.
    var _sizes = cardSizes(cardEl);
    var swatchLinks = Array.prototype.slice.call(
      cardEl.querySelectorAll(SWATCH_LINK_SEL), 0, PRELOAD_MAX_COLORWAYS
    );
    swatchLinks.forEach(function(a){
      var h = handleFromHref(a.getAttribute('href'));
      if (!h) return;
      _plSchedule(function(){
        return fetchProduct(h).then(function(j){
          if (!j) return;
          var imgs = (j.images || []).slice(0, 1);
          return Promise.allSettled(imgs.map(function(u){ return preload(u, _sizes); }));
        });
      });
    });
  };

  // Refresh the single-variant Add to Cart link + its variant id when color switches.
  function updateQuickAdd(c, product){
    var link = quickAddLinkEl(c);
    var variants = product.variants || [];
    var isSingle = variants.length === 1 && variants[0].title === 'Default Title';
    if (link && isSingle && product.available) {
      // Strip any leftover --adding / --added / error inline styles so the link
      // isn't lingering in a pill-button appearance from a prior add-to-cart.
      link.classList.remove('quick-add-sizes__btn--adding', 'quick-add-sizes__btn--added');
      link.style.borderColor = '';
      link.style.backgroundColor = '';
      link.style.color = '';
      link.textContent = 'Add to Cart';
      link.setAttribute('data-variant-id', String(variants[0].id));
      link.disabled = false;
    }
    // For multi-variant or sold-out cases, the reveal content will need to be
    // rebuilt — handled by the full-reveal refresh if implemented. For now we
    // just keep the link accurate when staying within the single-variant family.
  }

  // Card money is whole dollars rounded UP — mirrors the divided_by / modulo
  // ceiling in price-list.liquid, so a price rebuilt here can never disagree
  // with the server-rendered one it replaces.
  function formatMoney(cents){
    return '$' + Math.ceil((Number(cents) || 0) / 100);
  }

  // The variant a card prices off, chosen the way price-list.liquid chooses it:
  // highest-priced when the product's prices vary, lowest otherwise.
  function cardVariant(product){
    var variants = (product.variants || []).slice().sort(function(a, b){ return a.price - b.price; });
    if (!variants.length) return null;
    return product.price_varies ? variants[variants.length - 1] : variants[0];
  }

  // Update the price slot: either price or "SOLD OUT" label based on product.available.
  // Rebuilds the same <sale-price> + <compare-at-price> pair price-list.liquid
  // renders. Emitting only <sale-price> dropped the strikethrough, so every card
  // on a sale collection went from "$28 $78" to a bare "$28" on the first swatch tap.
  function updatePriceSlot(c, product){
    var el = priceEl(c);
    if (!el) return;

    if (!product.available) {
      var div = document.createElement('div');
      div.className = 'product-card__sold-out-price Pricing h6 text-subdued';
      div.setAttribute('aria-label', 'Sold Out');
      div.textContent = 'SOLD OUT';
      el.replaceWith(div);
      return;
    }

    var variant = cardVariant(product);
    var price = variant ? variant.price : (product.price != null ? product.price : product.price_min);
    var compareAt = variant ? variant.compare_at_price : product.compare_at_price;
    var onSale = compareAt != null && price < compareAt;

    // Same class strings price-list.liquid builds for context 'card' while
    // settings.product_card_text_font is 'heading'.
    var REGULAR_CLASSES = 'Pricing h6 text-subdued';
    var ON_SALE_CLASSES = 'Pricing h6 text-on-sale';
    var COMPARE_AT_CLASSES = 'Pricing h6 text-subdued line-through';

    // Liquid takes the on-sale styling unconditionally in the price_varies branch.
    var saleClasses = (product.price_varies || onSale) ? ON_SALE_CLASSES : REGULAR_CLASSES;

    var html =
      '<sale-price class="' + saleClasses + '">' +
        '<span class="sr-only">Sale price</span>' + formatMoney(price) +
      '</sale-price>';

    if (onSale) {
      html +=
        '<compare-at-price class="' + COMPARE_AT_CLASSES + '">' +
          '<span class="sr-only">Regular price</span>' + formatMoney(compareAt) +
        '</compare-at-price>';
    }

    var wrap = document.createElement('price-list');
    wrap.className = 'price-list';
    wrap.setAttribute('data-product-id', product.id);
    wrap.innerHTML = html;
    el.replaceWith(wrap);
  }

  // Update the product-card state classes (pc--multi-variant / pc--single-variant / pc--sold-out)
  // based on the fetched product's variant count + availability.
  function updateStateClasses(c, product){
    var variants = product.variants || [];
    var isSingle = variants.length === 1 && variants[0].title === 'Default Title';
    c.classList.remove('pc--multi-variant', 'pc--single-variant', 'pc--sold-out');
    if (isSingle) {
      c.classList.add(product.available ? 'pc--single-variant' : 'pc--sold-out');
    } else {
      c.classList.add('pc--multi-variant');
    }
  }

  function baseTitle(text){
    var t = String(text || '').trim();
    var i = t.indexOf(' - ');
    return i === -1 ? t : t.slice(0, i);
  }

  // Mirrors the liquid parsing in product-card.liquid so DSG / title / color
  // are extracted the same way from product.title:
  //   "DSG-0865. TETRA-LITE® 5" LINER SHORT - Dark Earth \"Wings\"/Black"
  function parseProductTitle(full){
    var out = { dsg: '', title: '', color: '' };
    if (!full) return out;
    var rest = full;
    var dotIdx = rest.indexOf('. ');
    if (dotIdx !== -1) {
      out.dsg = rest.slice(0, dotIdx);
      rest = rest.slice(dotIdx + 2);
    }
    var dashIdx = rest.indexOf(' - ');
    if (dashIdx !== -1) {
      out.title = rest.slice(0, dashIdx).trim();
      out.color = rest.slice(dashIdx + 3).trim();
    } else {
      out.title = rest.trim();
    }
    return out;
  }

  var CHEVRON_LEFT_SVG = '<svg aria-hidden="true" focusable="false" fill="none" width="18" viewBox="0 0 10 10"><path d="M7 1 3 5l4 4" stroke="currentColor" stroke-linecap="square"/></svg>';
  var CHEVRON_RIGHT_SVG = '<svg aria-hidden="true" focusable="false" fill="none" width="18" viewBox="0 0 10 10"><path d="m3 9 4-4-4-4" stroke="currentColor" stroke-linecap="square"/></svg>';

  // Rebuild the gallery images + nav + progress for a card from a product JSON object.
  function rebuildGallery(c, product) {
    var mediaA = mediaLink(c);
    var figure = figureEl(c);
    if (!mediaA || !figure || !product) return;

    var imgs = (product.images || []).slice(0, 5);
    if (imgs.length === 0) return;

    // Build alt text lookup from product.media
    var altMap = {};
    (product.media || []).forEach(function(m) {
      if (m.src) altMap[m.src.replace(/^https?:/, '')] = m.alt || '';
    });

    // Preserve classes from any existing gallery media so aspect ratios carry over
    var existing = mediaA.querySelector('.product-gallery__media');
    var baseClass = existing ? existing.className.replace(/\s*\bactive\b\s*/, ' ').replace(/\s*\bflatlay\b\s*/, ' ').trim() : 'product-gallery__media snap-center';

    // Find (or create) the track wrapper and reset it.
    // Snap back to index 0 without animation on product swap.
    var track = mediaA.querySelector('[data-gallery-track]');
    if (!track) {
      track = document.createElement('div');
      track.className = 'product-card__gallery-track';
      track.setAttribute('data-gallery-track', '');
      mediaA.appendChild(track);
    }
    // Reset gallery to first image without animation (both transform and scroll
     // mechanisms covered — desktop used transform before, scroll-based now).
    track.style.transition = 'none';
    track.style.transform = 'translateX(0%)';
    track.scrollLeft = 0;
    void track.offsetWidth;
    // Wipe existing gallery images (from either the track or the media link root)
    mediaA.querySelectorAll('.product-gallery__media').forEach(function(n){ n.remove(); });

    var _rebuildSizes = cardSizes(c);
    imgs.forEach(function(src, i){
      var img = document.createElement('img');
      var alt = altMap[src.replace(/^https?:/, '')] || '';
      var cls = baseClass + (i === 0 ? ' active' : '');
      if (alt && alt.toLowerCase().indexOf('flatlay') !== -1) cls += ' flatlay';
      img.className = cls;
      var ss2 = sizedSrcset(src);
      if (ss2) { img.sizes = _rebuildSizes; img.srcset = ss2; }
      img.src = ss2 ? sizedUrl(src, 600) : src;
      img.loading = 'lazy';
      if (i > 0) img.setAttribute('fetchpriority', 'low');
      img.setAttribute('data-index', i);
      track.appendChild(img);
    });

    // Wipe existing nav + progress
    figure.querySelectorAll('.product-card__nav, .product-card__progress').forEach(function(n){ n.remove(); });

    if (imgs.length > 1) {
      var prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'product-card__nav prev';
      prev.setAttribute('aria-label', 'Previous image');
      prev.setAttribute('data-gallery-prev', '');
      prev.innerHTML = CHEVRON_LEFT_SVG;
      figure.appendChild(prev);

      var next = document.createElement('button');
      next.type = 'button';
      next.className = 'product-card__nav next';
      next.setAttribute('aria-label', 'Next image');
      next.setAttribute('data-gallery-next', '');
      next.innerHTML = CHEVRON_RIGHT_SVG;
      figure.appendChild(next);

      var progress = document.createElement('div');
      progress.className = 'product-card__progress';
      progress.setAttribute('data-gallery-progress', '');
      progress.style.setProperty('--gallery-count', imgs.length);
      for (var i = 0; i < imgs.length; i++) {
        var seg = document.createElement('span');
        seg.className = 'product-card__progress-seg' + (i === 0 ? ' is-active' : '');
        seg.setAttribute('data-seg-index', i);
        progress.appendChild(seg);
      }
      figure.appendChild(progress);
    }

    if (typeof window.__rebuildProductCardGallery === 'function') {
      window.__rebuildProductCardGallery(c);
    }
    // Restore transition after rebuild + reflow so future prev/next still animates
    requestAnimationFrame(function () {
      track.style.transition = '';
    });
  }

  function selectInGroup(a){
    var group = a.closest('[data-card-swatches-track]');
    if (!group) return;
    group.querySelectorAll(SWATCH_SEL).forEach(function(n){
      n.classList.remove('is-selected');
    });
    a.classList.add('is-selected');
  }

  // Click: intercept navigation, swap images + title
  document.addEventListener('click', function(e){
    var a = e.target.closest(SWATCH_LINK_SEL);
    if (!a) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var c = card(a);
    if (!c) return;

    var href = a.getAttribute('href');
    var handle = handleFromHref(href);
    if (!handle) return;

    if (c.dataset.activeHandle === handle) {
      selectInGroup(a);
      return;
    }

    var mA = mediaLink(c); if (mA) mA.href = href;

    var labelEl = a.querySelector('.sr-only');
    var colorLabel = labelEl ? labelEl.textContent.trim() : '';

    var tA = titleLink(c);
    if (tA) {
      tA.textContent = baseTitle(tA.textContent);
      tA.href = href;
    }

    // Instant color-name update from the clicked swatch's label (no network wait).
    // The fetched product.title below will refine it if it differs.
    var cA = colorLink(c);
    if (cA) {
      if (colorLabel) cA.textContent = colorLabel;
      cA.href = href;
    }

    selectInGroup(a);

    if (c.__swatchCtrl) try { c.__swatchCtrl.abort(); } catch(_){}
    var ctrl = new AbortController();
    c.__swatchCtrl = ctrl;
    c.__swatchToken = (c.__swatchToken || 0) + 1;
    var token = c.__swatchToken;

    fetchProduct(handle, ctrl.signal).then(function(j){
      if (!j || token !== c.__swatchToken) return;
      var imgs = (j.images || []).slice(0, 5);
      // Preload first image so the swap isn't jarring
      var _swapSizes = cardSizes(c);
      return Promise.allSettled(imgs.slice(0, 2).map(function(u){ return preload(u, _swapSizes); })).then(function(){
        if (token !== c.__swatchToken) return;
        rebuildGallery(c, j);

        // Update title + color-name + DSG from the variant product's title
        var parsed = parseProductTitle(j.title || '');
        var tA2 = titleLink(c);
        if (tA2 && parsed.title) tA2.textContent = parsed.title;
        var cA2 = colorLink(c);
        if (cA2 && parsed.color) cA2.textContent = parsed.color;
        var dEl = dsgEl(c);
        if (dEl && parsed.dsg) dEl.textContent = 'DSG-' + parsed.dsg;

        // Update price slot (or SOLD OUT label), state classes, and the quick-add link
        updatePriceSlot(c, j);
        updateStateClasses(c, j);
        updateQuickAdd(c, j);

        c.dataset.activeHandle = handle;
      });
    }).catch(function(){});
  }, true);

  // Keyboard
  document.addEventListener('keydown', function(e){
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var a = e.target.closest(SWATCH_LINK_SEL);
    if (!a) return;
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    a.click();
  }, true);

  // Prefetch on hover
  document.addEventListener('mouseover', function(e){
    var a = e.target.closest(SWATCH_LINK_SEL);
    if (!a) return;
    var handle = handleFromHref(a.getAttribute('href'));
    if (!handle || cache[handle]) return;
    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ if (j) cache[handle] = j; })
      .catch(function(){});
  }, { passive: true });

  // Carousel arrows
  function setupArrows(wrap){
    var track = wrap.querySelector('[data-card-swatches-track]');
    var prev = wrap.querySelector('[data-swatches-prev]');
    var next = wrap.querySelector('[data-swatches-next]');
    if (!track || !prev || !next) return;
    if (wrap.__swatchArrowsBound) return;
    wrap.__swatchArrowsBound = true;

    // One-time: instantly scroll the track to show the initially-selected swatch.
    // No DOM reordering — swatches stay in their natural order so scrollLeft is
    // never forcibly reset. After this, JS never touches scrollLeft unprompted.
    requestAnimationFrame(function() {
      var selected = track.querySelector('a.color-swatch.is-selected, a.thumbnail-swatch.is-selected');
      if (!selected) return;
      var tRect = track.getBoundingClientRect();
      var eRect = selected.getBoundingClientRect();
      if (eRect.right > tRect.right + 1 || eRect.left < tRect.left - 1) {
        track.style.scrollBehavior = 'auto';
        track.scrollLeft = track.scrollLeft + (eRect.left - tRect.left);
        requestAnimationFrame(function() { track.style.scrollBehavior = ''; updateArrows(); });
      }
    });

    function getUnit(){
      var swatch = track.querySelector(SWATCH_SEL);
      if (!swatch) return 24;
      var gap = parseFloat(getComputedStyle(track).gap) || 5;
      return swatch.getBoundingClientRect().width + gap;
    }

    // Read-only: returns the max-width the track should have, or undefined.
    function measureMaxWidth(){
      var swatch = track.querySelector(SWATCH_SEL);
      if (!swatch) return;

      var gap = parseFloat(getComputedStyle(track).gap) || 5;
      var swatchW = swatch.getBoundingClientRect().width;
      var unit = swatchW + gap;
      var total = track.querySelectorAll(SWATCH_SEL).length;

      // Measure cardWidth BEFORE touching maxWidth.
      // The old pattern was: clear maxWidth → read clientWidth → set maxWidth.
      // Reading clientWidth after clearing maxWidth forced a reflow where the track
      // was temporarily unconstrained. If scrollLeft > scrollWidth at that moment,
      // the browser clipped it to 0. cardEl.clientWidth is grid-determined —
      // independent of track.style.maxWidth — so we can measure it safely first.
      var cardEl = wrap.closest('product-card');
      if (!cardEl) return;
      var cardWidth = cardEl.clientWidth;

      // How many swatches fit in the card width (accounting for ~32px padding budget).
      var available = cardWidth - 32;
      var fit = Math.floor((available + gap) / unit);
      if (fit < 1) fit = 1;
      // Cap to 4 visible max; carousel arrows handle overflow beyond that.
      if (fit > 4) fit = 4;

      // +3px compensates for the padding-right: 3px on the track (CSS) so that
      // 4 swatches still fill the visible area and the selected-state ring on
      // the rightmost swatch has room to breathe without being clipped.
      return (fit >= total) ? '' : ((fit * unit - gap + 3) + 'px');
    }

    // Only write if the value actually changed. Also save/restore scrollLeft in
    // case the layout change clips it.
    function applyMaxWidth(newMaxWidth){
      if (newMaxWidth === undefined) return;
      if (track.style.maxWidth !== newMaxWidth) {
        var sl = track.scrollLeft;
        track.style.maxWidth = newMaxWidth;
        if (track.scrollLeft !== sl) {
          track.scrollLeft = sl;
        }
      }
    }

    function readArrows(){
      return {
        atStart: track.scrollLeft <= 1,
        atEnd: track.scrollLeft + track.clientWidth >= track.scrollWidth - 1,
        hasOverflow: track.scrollWidth > track.clientWidth + 1
      };
    }

    function updateArrows(){ applyArrows(readArrows()); }

    function applyArrows(st){
      var atStart = st.atStart, atEnd = st.atEnd, hasOverflow = st.hasOverflow;

      prev.classList.toggle('is-shown', hasOverflow);
      next.classList.toggle('is-shown', hasOverflow);
      prev.classList.toggle('is-visible', hasOverflow && !atStart);
      next.classList.toggle('is-visible', hasOverflow && !atEnd);
    }

    // Find the currently selected swatch link and its position in the track
    function allSwatchLinks(){
      return Array.prototype.slice.call(track.querySelectorAll('a.color-swatch, a.thumbnail-swatch'));
    }
    function currentIndex(){
      var links = allSwatchLinks();
      for (var i = 0; i < links.length; i++) {
        if (links[i].classList.contains('is-selected')) return i;
      }
      return 0;
    }
    function ensureVisible(el){
      if (!el) return;
      // Scroll the track so the selected swatch is visible within the clamped area
      var elRect = el.getBoundingClientRect();
      var trackRect = track.getBoundingClientRect();
      if (elRect.right > trackRect.right) {
        track.scrollBy({ left: elRect.right - trackRect.right + 4, behavior: 'smooth' });
      } else if (elRect.left < trackRect.left) {
        track.scrollBy({ left: elRect.left - trackRect.left - 4, behavior: 'smooth' });
      }
    }

    // Paginate the visible window as the user arrows through colors so a new
    // variant comes into view with each click.
    //   side = 'left'  → put target at the LEFT edge of the visible track
    //                    (shifts window right, exposes a new swatch on the right)
    //   side = 'right' → put target at the RIGHT edge
    //                    (shifts window left, exposes a new swatch on the left)
    function paginateTo(target, side){
      if (!target) return;
      var trackRect = track.getBoundingClientRect();
      var elRect = target.getBoundingClientRect();
      var offset = side === 'left'
        ? elRect.left - trackRect.left
        : elRect.right - trackRect.right;
      if (Math.abs(offset) > 1) {
        track.scrollBy({ left: offset, behavior: 'smooth' });
      }
    }

    // Arrows now select the prev/next COLOR VARIANT (not just scroll the track).
    // Clicking the underlying swatch link triggers the full swap flow elsewhere
    // in this file (images, title, price, state classes, quick-add link, etc).
    prev.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      if (!prev.classList.contains('is-visible')) return;
      var links = allSwatchLinks();
      var idx = currentIndex();
      if (idx > 0) {
        var target = links[idx - 1];
        target.click();
        paginateTo(target, 'right');
      }
    });

    next.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();
      if (!next.classList.contains('is-visible')) return;
      var links = allSwatchLinks();
      var idx = currentIndex();
      if (idx < links.length - 1) {
        var target = links[idx + 1];
        target.click();
        paginateTo(target, 'left');
      }
    });

    track.addEventListener('scroll', updateArrows, { passive: true });

    // Desktop: when cursor enters the prev arrow zone (which sits off-screen at
    // left:-36px), slide the whole wrap right so the arrow comes into view. Stays
    // shifted while cursor is anywhere inside the wrap. Slides back on wrap leave.
    prev.addEventListener('mouseenter', function(){
      if (prev.classList.contains('is-visible')) {
        wrap.classList.add('is-sliding-left');
      }
    });
    wrap.addEventListener('mouseleave', function(){
      wrap.classList.remove('is-sliding-left');
    });
    // After clicking a swatch OR the prev arrow, slide back — but WAIT for the
    // swatch selection animation to finish first so both don't fire simultaneously.
    // Uses capture phase because the main swatch click handler calls
    // stopPropagation in capture, blocking bubble-phase listeners on the track.
    function slideBackDelayed(){
      setTimeout(function(){
        wrap.classList.remove('is-sliding-left');
      }, 400);
    }
    track.addEventListener('click', slideBackDelayed, true);
    prev.addEventListener('click', slideBackDelayed);

    // Preserve scroll position across hover/unhover cycles.
    // The browser resets scrollLeft during the opacity/max-height CSS transition
    // (while the reveal is invisible). Three-pronged approach:
    //   1. Save on mouseleave (reliable snapshot before collapse)
    //   2. Scroll listener while not hovered — catches any browser reset and undoes
    //      it instantly (scroll-behavior: auto in CSS, so no animation loop)
    //   3. Restore on mouseenter as safety net (in case reset happens late)
    var _savedScrollLeft = 0;
    var _isHovered = false;
    var _hoverCard = wrap.closest('product-card');
    if (_hoverCard) {
      _hoverCard.addEventListener('mouseenter', function() {
        _isHovered = true;
        if (_savedScrollLeft > 0 && track.scrollLeft !== _savedScrollLeft) {
          track.scrollLeft = _savedScrollLeft; // instant — scroll-behavior: auto in CSS
          updateArrows();
        }
      }, { passive: true });

      _hoverCard.addEventListener('mouseleave', function() {
        _savedScrollLeft = track.scrollLeft;
        _isHovered = false;
      }, { passive: true });

      // While not hovered: pointer-events:none means only the BROWSER can scroll the
      // track. Any scroll change here = browser reset. Undo it immediately.
      track.addEventListener('scroll', function() {
        if (!_isHovered && _savedScrollLeft > 0 && track.scrollLeft !== _savedScrollLeft) {
          track.scrollLeft = _savedScrollLeft;
        }
      }, { passive: true });
    }

    var layoutJob = {
      measure: measureMaxWidth, applyWidth: applyMaxWidth,
      readArrows: readArrows, applyArrows: applyArrows
    };
    queueLayout(layoutJob);

    // Card width is all that changes the clamp. Height changes (images loading,
    // the meta/reveal vars) fired this constantly and are ignored.
    var cardEl = wrap.closest('product-card') || wrap.parentElement;
    var lastCardWidth = -1;
    new ResizeObserver(function(entries){
      var cw = entries[0] ? entries[0].contentRect.width : 0;
      if (cw === lastCardWidth) return;
      var firstCallback = lastCardWidth === -1;
      lastCardWidth = cw;
      if (!firstCallback) queueLayout(layoutJob);
    }).observe(cardEl);
  }

  // Every row's clamp + arrows run in one frame, phased so the page lays out
  // twice in total instead of twice per card: all clamp reads, all clamp writes,
  // all arrow reads (they depend on the new max-width), all arrow writes.
  var layoutQueue = [];
  function queueLayout(job){
    if (layoutQueue.indexOf(job) !== -1) return;
    if (!layoutQueue.length) requestAnimationFrame(flushLayout);
    layoutQueue.push(job);
  }
  function flushLayout(){
    var jobs = layoutQueue;
    layoutQueue = [];
    var widths = jobs.map(function(j){ return j.measure(); });
    jobs.forEach(function(j, i){ j.applyWidth(widths[i]); });
    var arrows = jobs.map(function(j){ return j.readArrows(); });
    jobs.forEach(function(j, i){ j.applyArrows(arrows[i]); });
  }

  function init(){
    document.querySelectorAll('[data-card-swatches-wrap]').forEach(setupArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  new MutationObserver(function(){
    document.querySelectorAll('[data-card-swatches-wrap]:not([data-bound])').forEach(function(w){
      w.setAttribute('data-bound', '');
      setupArrows(w);
    });
  }).observe(document.body, { childList: true, subtree: true });
})();





